import Client from './client';

export default class AllOrganizationsMemberships extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postAll(options = {}) {
    return this.makeRequest(`${this.host}/internal/organizations/membership/all`, {
      ...options,
       method: 'POST',
    });
  }

}
